import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { QuickLinksFloatingComponent } from './quick-links-floating/quick-links-floating.component';
import { QuickLinksSearchModalComponent } from './quick-links-search-modal/quick-links-search-modal.component';

@NgModule({
  declarations: [
    QuickLinksFloatingComponent,
    QuickLinksSearchModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatAutocompleteModule
  ],
  exports: [
    QuickLinksFloatingComponent
  ]
})
export class QuickLinksModule { }
